/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Grid, FormLabel } from "@material-ui/core";
import PropTypes from "prop-types";

/**
 * Displays Read only label and value with a spacing. will not display when `value` is empty
 * @param { string } label displayed on left side with grayed black color.
 * @param { string } value displayed on right side with dark black color.
 */
const ReadOnlyLabel = ({ label, value }) =>
	value && (
		<Grid className="d-flex align-items-center justify-content-between pt-4 px-3">
			<Grid>
				<FormLabel style={{ marginRight: 20 }}>{label} </FormLabel>
				<FormLabel style={{ color: "black" }}>{value}</FormLabel>
			</Grid>
		</Grid>
	);

ReadOnlyLabel.defaultProps = {
	value: "",
};
ReadOnlyLabel.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
};

export default ReadOnlyLabel;
